if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
      this.unreachedMessage = this.querySelector('.free-shipping-bar__unreached-message');
      this.reachedMessage = this.querySelector('.free-shipping-bar__reached-message');
      if(this.unreachedMessage) {
        this.unreachedMessageText = this.unreachedMessage.innerHTML;
      }
      this.percentNumber = this.querySelector('.free-shipping-bar__progress-number');
      if (this.dataset.showExcludeMessage) {
        this.countExcludeProducts = parseInt(this.dataset.countExcludeProducts);
        this.excludeMessage = this.querySelector('.free-shipping-bar__exclude-message');
        this.excludeMessageText = this.excludeMessage.innerHTML;
        this.toggleExcludeMessage()
      }
      if(!this.dataset.threshold) return;
      this.threshold = parseInt(this.dataset.threshold);
      this.calculateBar(parseInt(this.dataset.total));
      this.onCartChangeHandler = this.onCartChange.bind(this);
      document.addEventListener('afterCartChanged', this.onCartChangeHandler);
      document.addEventListener('afterUpdateQuantity', this.onCartChangeHandler);
    }
    static get observedAttributes() { return ['data-total']; } attributeChangedCallback(n, o, v) { if (n !== 'data-total' || o === v || !this.threshold) return; const t = parseInt(v); if (!isNaN(t)) this.calculateBar(t); }

    disconnectedCallback() {
      document.removeEventListener('afterCartChanged', this.onCartChangeHandler);
      document.removeEventListener('afterUpdateQuantity', this.onCartChangeHandler);
    }

    calculateBar(currentTotal) {
      const total = currentTotal / parseFloat(Shopify.currency.rate);
      // maligo® Gamification: nur wenn die Grenze GERADE überschritten wurde (nicht bei jedem Öffnen)
      let wasReached = null;
      try { wasReached = sessionStorage.getItem('mgFsReached'); } catch (e) {}
      const reached = total >= this.threshold;
      try { sessionStorage.setItem('mgFsReached', reached ? '1' : '0'); } catch (e) {}
      if (reached && wasReached === '0') this.celebrate();
      if(total >= this.threshold) {
        this.style.setProperty('--percent', '100%');
        this.classList.add('completed');
        this.hideUnreachedMessage();
        this.showReachedMessage();
        this.percentNumber.textContent = `100%`;
      }  else {
        const remain = this.threshold - total;
        const percent = (total * 100) / this.threshold;
        this.style.setProperty('--percent', `${percent}%`);
        this.classList.remove('completed');
        this.hideReachedMessage();
        this.showUnreachedMessage(remain);
        this.percentNumber.textContent = `${Math.floor(percent)}%`;
      }
    }

    celebrate() {
      this.classList.remove('mg-celebrate');
      void this.offsetWidth;
      this.classList.add('mg-celebrate');
      const box = document.createElement('span');
      box.className = 'mg-fs-confetti';
      box.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 14; i++) {
        const p = document.createElement('i');
        const a = (Math.PI * 2 * i) / 14 + Math.random() * 0.4;
        const d = 40 + Math.random() * 50;
        p.style.setProperty('--x', `${Math.cos(a) * d * 1.6}px`);
        p.style.setProperty('--y', `${Math.sin(a) * d}px`);
        p.style.setProperty('--r', `${Math.round(Math.random() * 360)}deg`);
        p.style.animationDelay = `${Math.random() * 0.08}s`;
        box.appendChild(p);
      }
      this.appendChild(box);
      setTimeout(() => { box.remove(); this.classList.remove('mg-celebrate'); }, 1400);
    }

    toggleExcludeMessage() {
      if (!this.dataset.showExcludeMessage) {
          return
      }
      if (!this.countExcludeProducts) {
          this.excludeMessage.classList.add('hidden')
      } else {
          this.excludeMessage.innerHTML = this.excludeMessageText.replace('[product_count]', this.countExcludeProducts);
          this.excludeMessage.classList.remove('hidden')
      }
    }

    onCartChange() {
      fetch(`${routes.cart_url}`, {...fetchConfig('json', 'GET')})
      .then((response) => response.json())
      .then((response) => {
        let totalPrice = response.total_price;
        if (freeShippingBarExcludeProducts.length > 0 && response.items.length > 0) {
          this.countExcludeProducts = 0;
          response.items.forEach((item) => {
            if(freeShippingBarExcludeProducts.includes(item.product_id)) {
              totalPrice -= item.final_line_price;
              this.countExcludeProducts++
            }
          });
        }
        this.calculateBar(totalPrice);
        this.toggleExcludeMessage()
      });
    }

    showUnreachedMessage(remainAmount) {
      if(!this.unreachedMessageText && this.unreachedMessage) return;
      // maligo® (15.10.2026): auf Deutsch „97,00 €“ statt „€97,00“
      const lang = (document.documentElement.lang || '').toLowerCase();
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      const remainPrice = lang.startsWith('de') && cur === 'EUR'
        ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(remainAmount / 100)
        : Shopify.showPrice(remainAmount);
      this.unreachedMessage.classList.remove('hidden');
      this.unreachedMessage.innerHTML = this.unreachedMessageText.replace('[remain]', `${remainPrice}`);
    }

    hideUnreachedMessage() {
      if(!this.unreachedMessage) return;
      this.unreachedMessage.classList.add('hidden');
    }

    showReachedMessage(remainAmount) {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.remove('hidden')
    }

    hideReachedMessage() {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.add('hidden');
    }
  });
}
